var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { loginCT } from "./constants/login.constants";
import { LoginView_ah } from "./view";
import { LoadingAFY, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import { useAuth } from "../../authContext";
import { useNavigate } from "react-router-dom";
import LocalStorageService from "../../services/localStorage";
import { GetMenuHeader, GetMenuSideBarHome } from "../../services/nav";
import showToast from "../../services/toast";
import { getCustomerAction } from "../../fnx/customer";
import { useDispatch, useSelector } from "react-redux";
import i18Next from "i18next";
import { useTranslation } from "react-i18next";
import { loginUser, loginUserClearData, userConfirmEmailClearData, userConfirmPasswordClearData, userPasswordResetClearData, } from "../../store/auth/actions";
import { showErrorToast } from "../../fnx/showError";
import { byPassLogin, handleMicrosoftLogin, postSSOValidation, } from "../../../src/resources/helper/login";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
var Login = function () {
    var _a = React.useState(true), isFalseSSO = _a[0], setIsFalseSSO = _a[1];
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _b = useAuth(), status = _b.status, setStatus = _b.setStatus;
    var storageKey = "assurehub";
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var localStorageService = new LocalStorageService(storageKey);
    var t = useTranslation().t;
    var _d = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _d[0], setSeeToast = _d[1];
    var _e = useSelector(function (state) { return ({
        responseLogin: state.Login.responseLogin,
        errorLogin: state.Login.errorLogin,
        loadingLogin: state.Login.loadingLogin,
    }); }), responseLogin = _e.responseLogin, errorLogin = _e.errorLogin, loadingLogin = _e.loadingLogin;
    var onLoginSSO = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            handleMicrosoftLogin("");
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        var params = new URLSearchParams(window.location.search);
        var token = params.get("token");
        var clientId = params.get("clientId");
        if (token && clientId) {
            console.log("Token: ", token);
            console.log("ClientId: ", clientId);
            byPassLogin(token, clientId).then(function (response) {
                console.log("Response: ", response);
                handleLogin(response, token, true);
            });
        }
        else {
            setIsFalseSSO(false);
            var msiAccessToken = localStorage.getItem("msi_access_token");
            if (msiAccessToken) {
                setLoading(true);
                postSSOValidation(msiAccessToken).then(function (response) {
                    setLoading(false);
                    if (response) {
                        handleLogin(response, response.accessToken.jwtToken, true);
                    }
                    else {
                        setSeeToast({
                            show: true,
                            type: typeAlert.error,
                            message: t("Error al iniciar sesión"),
                        });
                        console.log("Error: No response from postSSOValidation");
                    }
                });
            }
            else {
                console.log("No MSI Access Token found in localStorage");
            }
        }
    }, []);
    var handleLogin = function (response, token, isBypass) {
        if (isBypass === void 0) { isBypass = false; }
        console.log("****isBypass****", isBypass);
        setIsFalseSSO(isBypass);
        try {
            var storageKeyMh = "afy-menuh";
            var storageKeyMs = "afy-menus";
            var lsMH = new LocalStorageService(storageKeyMh);
            var lsMS = new LocalStorageService(storageKeyMs);
            var userDetails = {
                token: token,
                userName: response.user.name,
                email: response.user.email,
                clientId: response.client.id,
                countryId: response.client.countryId,
                branchId: response.branch.id,
                userId: response.user.id,
                subdomain: response.client.subdomain,
                roles: response.user.roles,
            };
            if (!isBypass) {
                userDetails.idToken = {
                    jwtToken: response.accessToken.jwtToken,
                    payload: {
                        name: response.idToken.payload.name,
                        family_name: response.idToken.payload.family_name,
                    },
                };
            }
            else {
                userDetails.idToken = {
                    jwtToken: token,
                    payload: {
                        name: response.user.name,
                        family_name: response.user.family_name,
                    },
                };
            }
            localStorageService.setUserLoginStored(userDetails);
            if (getCustomerAction().customerAuto.includes(response.client.subdomain)) {
                localStorage.setItem("i18nextLng", "es");
                localStorage.setItem("i18nextDefaultNamespace", "apapauto");
                i18Next.loadNamespaces("apapauto", function () {
                    i18Next.setDefaultNamespace("apapauto");
                    i18Next.changeLanguage("es");
                });
            }
            else {
                localStorage.setItem("i18nextLng", "es");
                localStorage.setItem("i18nextDefaultNamespace", "default");
                i18Next.loadNamespaces("default", function () {
                    i18Next.setDefaultNamespace("default");
                    i18Next.changeLanguage("es");
                });
            }
            lsMH.setMenuHorizontalStored(GetMenuHeader());
            lsMS.setMenuSideBarStored(GetMenuSideBarHome());
            setStatus("authenticated");
        }
        catch (error) {
            console.log("Error on login: ", error);
        }
    };
    useEffect(function () {
        if (responseLogin) {
            handleLogin(responseLogin, status, false);
        }
    }, [responseLogin]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (errorLogin) {
            var error = errorLogin;
            var message = void 0;
            showErrorToast(errorLogin === null || errorLogin === void 0 ? void 0 : errorLogin.response, setSeeToast, t);
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.errors) !== undefined) {
                var key = "login.errors.".concat((_b = error.response.errors[0]) === null || _b === void 0 ? void 0 : _b.message);
                message = t(key);
            }
            else {
                console.log("Error: ", (_c = error.response) === null || _c === void 0 ? void 0 : _c.message);
                message = t("error");
            }
            if (error) {
                if (((_e = (_d = error.response) === null || _d === void 0 ? void 0 : _d.errors[0]) === null || _e === void 0 ? void 0 : _e.message) === "USER_NOT_CONFIRMED") {
                    dispatch(loginUserClearData());
                    dispatch(userConfirmEmailClearData());
                    navigate("/confirmEmail");
                }
            }
        }
    }, [errorLogin]);
    var onClickForgetPassword = function () {
        dispatch(userPasswordResetClearData());
        dispatch(userConfirmPasswordClearData());
        navigate("/passwordReset");
    };
    var lgSingIn = function (form) {
        var storageKeyMh = "afy-menuh";
        var storageKeyMs = "afy-menus";
        var lsMH = new LocalStorageService(storageKeyMh);
        var lsMS = new LocalStorageService(storageKeyMs);
        /*    lsMH.setMenuHorizontalStored([]);
        lsMS.setMenuSideBarStored(GetMenuSideBarHome());
        lsMS.setMenuSideBarStored(GetMenuSideBarAdministration());
           */
        dispatch(loginUser({
            userName: form.email,
            password: form.password,
        }));
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingLogin, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: t("login.loadingLogin") }), loading && (_jsx(LoadingAFY, { loading: loading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: t("login.loadingLogin"), textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third })), !isFalseSSO ? (_jsx(LoginView_ah, __assign({}, loginCT, { onSignIn: function (form) {
                    lgSingIn(form);
                    return form;
                }, onSubmitSSO: function (data) {
                    handleMicrosoftLogin(data);
                } }))) : (_jsx(LoadingAFY, { loading: !loadingLogin, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: t("login.loadingLogin"), textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }))] }));
};
export default Login;
